import React, { useEffect, useState } from "react";
import ComboBox from "../../Components/ComboBox";

function DesignerCombo({setFieldValue, options,lable ,filedName}) {
  const [value, setValue] = useState("00000000-0000-0000-0000-000000000000");
  const [inputValue, setInputValue] = useState("");
  const optionConvert=options?.map(item=>({label:item.key,value:item.value}))
  useEffect(() => {
    setFieldValue(filedName?filedName:"designerId", value);
  }, [value]);
  return (
    <ComboBox
      lable={lable?lable:"طراح"}
      inputValue={inputValue}
      setInputValue={setInputValue}
      value={value}
      setValue={setValue}
      options={optionConvert}
    />
  );
}

export default DesignerCombo;
